import DeviceDetails from "./DeviceDetails.tsx";
import Project from "./Project";
import Protocol from "./Protocol";
import {
  isDeviceSectionValid,
  isProjectSectionValid,
  isProtocolSectionValid,
} from "../../../models/Project.ts";

export const projectSetupSteps = [
  {
    id: "device-details",
    label: "Device",
    validation: isDeviceSectionValid,
    component: DeviceDetails,
  },
  {
    id: "protocol",
    label: "Protocol",
    validation: isProtocolSectionValid,
    component: Protocol,
  },
  {
    id: "project-details",
    label: "Project",
    validation: isProjectSectionValid,
    component: Project,
  },
];
